/* eslint-disable @calm/react-intl/missing-formatted-message */

import GridWrapper from '@/components/ui/GridWrapper';

import { JaySectionProps } from '../JayLandingPageLayout/types';
import {
	BodyText,
	ButtonWrapper,
	ContentColumn,
	DeviceImage,
	Heading,
	StyledButton,
	Wrapper,
} from './styles';

const Exclusive = ({ onCtaClick }: JaySectionProps) => {
	return (
		<Wrapper>
			<GridWrapper columns={2}>
				<div>
					<DeviceImage alt="Calm App with Daily Jay" src="/_n/images/jayshetty/jay-mobile-device.webp" />
				</div>
				<ContentColumn>
					<Heading>
						Join former monk, purpose coach and best-selling author Jay Shetty on a journey to...
					</Heading>
					<BodyText>
						<ul>
							<li>Take positive action toward the life of your dreams with the Daily Jay</li>
							<li>
								Reduce stress and anxiety — at home, at work, and everywhere in between — with one of Jay’s
								many relaxation exercises
							</li>
							<li>Fall asleep with gratitude with Jay’s soothing body scan</li>
						</ul>
					</BodyText>
					<ButtonWrapper>
						<StyledButton
							fullWidth
							onPress={() => {
								onCtaClick({
									section: 'program_preview',
									copy: 'Listen Now',
									pos: 2,
								});
							}}
							backgroundColor="jayBlue"
							textColor="white"
						>
							Listen Now
						</StyledButton>
					</ButtonWrapper>
				</ContentColumn>
			</GridWrapper>
		</Wrapper>
	);
};

export default Exclusive;
